var map = {
	"./404/1.svg": 753,
	"./404/2.svg": 754,
	"./404/3.svg": 755,
	"./404/4.svg": 756,
	"./404/404.svg": 757,
	"./404/5.svg": 758,
	"./404/6.svg": 759,
	"./404/bg.svg": 760,
	"./arrow.svg": 832,
	"./arrowfront.svg": 833,
	"./bgcard.jpg": 731,
	"./bgcardmedia/photo01.jpg": 834,
	"./bgcardmedia/photo02.jpg": 835,
	"./bgcardmedia/photo03.jpg": 836,
	"./booklook.svg": 837,
	"./bookunlook.svg": 838,
	"./boylogin.svg": 732,
	"./card.svg": 695,
	"./cardscore.svg": 839,
	"./characters/joe.png": 840,
	"./characters/mary.png": 841,
	"./climb.svg": 761,
	"./clock.png": 842,
	"./coin.svg": 679,
	"./conquistas/diamond.png": 843,
	"./conquistas/diamond.svg": 844,
	"./conquistas/star.svg": 845,
	"./conquistas/svg/1.svg": 686,
	"./conquistas/svg/10.svg": 687,
	"./conquistas/svg/2.svg": 688,
	"./conquistas/svg/3.svg": 689,
	"./conquistas/svg/4.svg": 666,
	"./conquistas/svg/5.svg": 690,
	"./conquistas/svg/6.svg": 691,
	"./conquistas/svg/7.svg": 692,
	"./conquistas/svg/8.svg": 693,
	"./conquistas/svg/9.svg": 694,
	"./conquistas/text.svg": 846,
	"./correct-icon.png": 847,
	"./correct-icon0.png": 848,
	"./crown.svg": 720,
	"./dollarmds.svg": 849,
	"./exercicies/words-attack/1.png": 850,
	"./exercicies/words-attack/intro.png": 657,
	"./favicon.png": 851,
	"./game/bg-card-blue.jpg": 740,
	"./game/bg-card-orange.jpg": 741,
	"./game/logo-card-blue.svg": 742,
	"./game/logo-card-orange.svg": 852,
	"./game/turn-blue.svg": 743,
	"./game/turn-orange.svg": 853,
	"./happymsg.svg": 854,
	"./heart.svg": 663,
	"./icon-books.svg": 193,
	"./icon-words.svg": 658,
	"./icon.png": 855,
	"./icons/alert-video.svg": 696,
	"./icons/arrow.svg": 856,
	"./icons/blockdash/again.svg": 697,
	"./icons/blockdash/attention.svg": 698,
	"./icons/blockdash/book.svg": 762,
	"./icons/blockdash/calendar.svg": 699,
	"./icons/blockdash/hourglass.svg": 700,
	"./icons/blockdash/negative.svg": 701,
	"./icons/blockdash/powerstart.svg": 857,
	"./icons/blockdash/prepare.svg": 702,
	"./icons/blockdash/review.svg": 858,
	"./icons/blockdash/start.svg": 703,
	"./icons/blockdash/think.svg": 667,
	"./icons/cancel.svg": 195,
	"./icons/check.svg": 656,
	"./icons/lock.svg": 859,
	"./icons/mic.svg": 744,
	"./icons/microphone.svg": 745,
	"./icons/replay.svg": 704,
	"./icons/twoarrow.svg": 661,
	"./icons/volume.svg": 860,
	"./intro.png": 861,
	"./load/jetspritesheet.png": 574,
	"./load/planet01.svg": 202,
	"./load/planet02.svg": 200,
	"./load/planet03.svg": 205,
	"./load/planet04.svg": 203,
	"./load/planet05.svg": 204,
	"./load/planet06.svg": 201,
	"./locklogin.svg": 733,
	"./logos/jet.svg": 705,
	"./logos/loadimg.svg": 206,
	"./logos/logo-all-black.svg": 783,
	"./logos/logo-black-blue.svg": 782,
	"./logos/logo-black-green.svg": 781,
	"./logos/logo-black-red.svg": 780,
	"./logos/logo-black.svg": 748,
	"./logos/logo-blue.svg": 786,
	"./logos/logo-green.svg": 785,
	"./logos/logo-login.svg": 706,
	"./logos/logo-red.svg": 784,
	"./logos/logo-white-orange.svg": 199,
	"./logos/logo-white.svg": 787,
	"./logos/logo.svg": 662,
	"./logos/minds-white.svg": 707,
	"./menu/book.svg": 683,
	"./menu/config.svg": 671,
	"./menu/home.svg": 682,
	"./menu/settings.svg": 670,
	"./menu/store.svg": 684,
	"./menu/user.png": 862,
	"./menu/words.svg": 685,
	"./my-logo.png": 863,
	"./nextprev.svg": 864,
	"./offline.jpg": 763,
	"./owl.svg": 764,
	"./password.svg": 765,
	"./personagens/1.svg": 865,
	"./personagens/2.svg": 669,
	"./personagens/bg/bg01.jpg": 746,
	"./personagens/bg/bg01.svg": 866,
	"./personagens/bg/bg02.jpg": 721,
	"./personagens/bg/bg02.png": 722,
	"./personagens/bg/bg03.jpg": 723,
	"./personagens/bg/masktest.png": 867,
	"./personagens/bloogApprentice.png": 660,
	"./playvideo.svg": 868,
	"./podcast.svg": 766,
	"./postervideo.jpg": 747,
	"./signin.svg": 767,
	"./star-unit.svg": 640,
	"./telas/1.png": 788,
	"./telas/2.png": 789,
	"./telas/3.png": 790,
	"./telas/4.png": 791,
	"./telas/5.png": 792,
	"./telas/6.png": 793,
	"./telas/7.png": 794,
	"./telas/8.png": 795,
	"./telas/9.png": 796,
	"./tonext.svg": 719,
	"./units/all_ears.svg": 708,
	"./units/another_brick.svg": 709,
	"./units/assessment.svg": 710,
	"./units/game.svg": 711,
	"./units/words_attack.svg": 712,
	"./video-heart.svg": 668,
	"./video-play.svg": 659,
	"./videoinicialposter.jpg": 869,
	"./wrong-icon.png": 870,
	"./xp.svg": 724
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 831;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = 831
// module chunks = 2 3 4 5